<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="vx-row">
                <div class="vx-col md:w-1/3 w-full mt-2">
                    <label class="vs-input--label">{{ this.$t('timeKeeping.branch') }}</label>
                    <v-select class="" v-model="selectedOrganizationBranch" :clearable="false"
                              :options="organizationBranchOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-2">
                    <label class="vs-input--label">{{ this.$t('timeKeeping.employee') }}</label>
                    <v-select class="" v-model="selectedEmployee" :clearable="false" :options="employeeOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>

                <div class="vx-col md:w-1/3 w-full mt-2">
                    <label class="vs-input--label">{{ this.$t('timeKeeping.alreadyCheckin') }}</label>
                    <v-select class="" v-model="selectedIsCheckIn" :clearable="false" :options="isCheckInOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col md:w-1/3 w-full mt-2">
                    <label class="vs-input--label">{{ this.$t('timeKeeping.late') }}</label>
                    <v-select class="" v-model="selectedIsLate" :clearable="false" :options="isLateOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-2">
                    <label class="vs-input--label">{{ this.$t('timeKeeping.times') }}</label>
                    <div class="flex-grow">
                        <date-range-picker
                            class="w-full"
                            ref="picker"
                            :locale-data="{format: 'dd/mm/yyyy' }"
                            :opens="'right'"
                            @update="dateRangePicker"
                            v-model="dateRange">
                        </date-range-picker>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-8 items-center">
                    <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                              v-model="searchQuery"
                              @input="updateSearchQuery" :placeholder="$t('button.search')"/>
                </div>
            </div>
            <div class="flex flex-wrap items-center mt-2">
                <vs-button class="mt-4 mr-4" @click="filter" :disabled="!validateForm">
                    {{ this.$t('timeKeeping.filter') }}
                </vs-button>
                <vs-button class="mt-4 mr-4" @click="exportFile" :disabled="!validateForm"
                           v-if="isPermissionAddReport()">{{ this.$t('timeKeeping.createReport') }}
                </vs-button>
                <vs-button class="mt-4" @click="$router.push('/user/history-file')" v-if="isPermissionAddReport()">
                    {{ $t('timeKeeping.historyExport') }}
                </vs-button>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh"
                         ref="agGridTable"
                         :components="components"
                         :gridOptions="gridOptions"
                         class="ag-theme-material w-100 my-4 ag-grid-table"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="workShiftData"
                         :animateRows="true"
                         :pagination="true"
                         :paginationPageSize="paginationPageSize"
                         :onGridReady="onGridReady"
                         :localeText=" {noRowsToShow: this.$t('menuCamera.noRowsToShow')} "
                         :suppressPaginationPanel="true">
            </ag-grid-vue>

            <div class="vx-row">
                <div class="w-full flex">
                    <div style="min-width:200px">
                        <span class="content-page font-bold ml-4">Hiển thị: </span><span
                        class="text-page">{{ countElementPage > totalElements ? totalElements : countElementPage }} / {{ totalElements }} </span>
                    </div>
                    <vs-pagination
                        :total="totalPages"
                        :max="maxPageNumbers"
                        v-model="currentPage"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import authConfig from '@/../auth_config.json';
import moment from 'moment'; // Vuesax
import Pagination from "../../../ui-elements/Pagination.vue"
import CellRendererActions from './cell-renderer/CellRendererActions.vue'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Datepicker from 'vuejs-datepicker';
import DateRangePicker from '../../../../components/vue2-daterange-picker/components/DateRangePicker.vue'
import {isAPI} from '../../../../store/permission';
import {constAPI} from '../../../../store/constant';

export default {
    components: {
        AgGridVue,
        vSelect,
        // Cell Renderer
        Datepicker,
        Pagination,
        CellRendererActions,
        DateRangePicker,
        flatPickr
    },
    data() {
        return {
            searchQuery: "",
            maxPageNumbers: 7,
            // AgGrid
            gridApi: null,
            gridOptions: {},
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('timeKeeping.employeeCode'),
                    field: 'employeeCode',
                    width: 100
                },
                {
                    headerName: this.$t('timeKeeping.fullName'),
                    field: 'fullName',
                    width: 200
                },
                {
                    headerName: this.$t('timeKeeping.shift'),
                    field: 'displayGroupName',
                    width: 200,
                },
                {
                    headerName: this.$t('timeKeeping.date'),
                    field: 'date',
                    width: 130,
                },
                {
                    headerName: this.$t('timeKeeping.onShift'),
                    field: 'checkinTime',
                    width: 130,
                },
                {
                    headerName: this.$t('timeKeeping.afterWork'),
                    field: 'checkoutTime',
                    width: 130,
                },
                {
                    headerName: this.$t('timeKeeping.typeCheckin'),
                    field: 'actionTypeName',
                    width: 130,
                },
                {
                    headerName: this.$t('timeKeeping.actions'),
                    field: 'actions',
                    width: 150,
                    cellRendererFramework: 'CellRendererActions',
                },
            ],
            // Cell Renderer Components
            components: {
                CellRendererActions
            },
            workShiftData: [],
            organizationBranchOptions: [],
            employeeOptions: [],
            selectedOrganizationBranchValue: null,
            selectedEmployeeValue: null,
            dateRange: {
                endDate: new Date(),
                startDate: (() => {
                    return new Date().setHours(0, 0, 0);
                })()
            },
            isCheckIn: null,
            isCheckInOptions: [
                {value: null, label: this.$t('menuOrganization.all')},
                {value: true, label: 'Đã check in'},
                {value: false, label: 'Chưa check in'}
            ],
            isLate: null,
            isLateOptions: [
                {value: null, label: this.$t('menuOrganization.all')},
                {value: true, label: 'Đi muộn'}
            ],
            countElementPage: 0,
            totalElements: 0,
        }
    },
    async created() {
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]')
        if (branchList.length === 0) {
            return this.$vs.notify({
                text: 'Hiện tại không tồn tại chi nhánh nào',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        }
        this.organizationBranchOptions = branchList.map(item => {
            return {value: item.id, label: item.organizationBranchName}
        })

        if (this.$route.query.isCheckin && this.$route.query.isCheckin === 'true') {
            this.selectedIsCheckIn = {value: true, label: 'Đã check in'};
        } else if (this.$route.query.isCheckin && this.$route.query.isCheckin === 'false') {
            this.selectedIsCheckIn = {value: false, label: 'Chưa check in'};
        }
        if (this.$route.query.employeeId) {
            this.selectedEmployeeValue = parseInt(this.$route.query.employeeId, 10);
            await this.getInfoEmployee();
            this.loadEmployee();
        }
        if (this.$route.query.isLate === 'true') {
            this.selectedIsLate = {value: true, label: 'Đi muộn'};
        }
        if (this.$route.query.theBestLate === 'true') {
            this.dateRange.startDate = new Date(new Date().setDate(new Date().getDate() - 1));
            this.dateRange.endDate = new Date(new Date().setDate(new Date().getDate() - 1));
        }

        let index = 0;
        if (this.selectedOrganizationBranch) {
            index = this.organizationBranchOptions.findIndex(item => item.value === this.selectedOrganizationBranch)
        }
        this.selectedOrganizationBranch = this.organizationBranchOptions[index > -1 ? index : 0];
        this.filter()
    },
    watch: {
        '$store.state.windowWidth'(val) {
            if (val <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.isUpdateCheckInCheckOut'(val) {
            if (val) {
                this.filter();
                this.$store.commit('UPDATE_CHECKIN_CHECKOUT', false);
            }
        }
    },
    computed: {
        paginationPageSize() {
            if (this.gridApi) return this.gridApi.paginationGetPageSize();
            else return 20
        },
        totalPages() {
            if (this.gridApi) return this.gridApi.paginationGetTotalPages();
            else return 0
        },
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1)
            }
        },
        selectedOrganizationBranch: {
            get() {
                return {
                    label: this.organizationBranchString(this.selectedOrganizationBranchValue),
                    value: this.selectedOrganizationBranchValue
                }
            },
            set(obj) {
                this.selectedOrganizationBranchValue = obj.value
                this.loadEmployee()
            }
        },
        selectedEmployee: {
            get() {
                let obj = this.employeeOptions.find(el => el.value === this.selectedEmployeeValue);
                if (!obj) return;
                return {
                    label: obj.label,
                    value: obj.value,
                }
            },
            set(obj) {
                this.selectedEmployeeValue = obj ? obj.value : null;
            }
        },
        selectedIsCheckIn: {
            get() {
                return {
                    label: this.isCheckinString(this.isCheckIn),
                    value: this.isCheckIn
                }
            },
            set(obj) {
                this.isCheckIn = obj.value
            }
        },
        selectedIsLate: {
            get() {
                return {
                    label: this.isLateString(this.isLate),
                    value: this.isLate
                }
            },
            set(obj) {
                this.isLate = obj.value
            }
        }
    },
    methods: {
        isPermissionAddReport() {
            return isAPI(this, constAPI.time_keeping_export)
        },
        dateRangePicker: function () {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59));
        },
        updateSearchQuery(val) {
            this.gridApi.setQuickFilter(val)
        },
        organizationBranchString(id) {
            let organizationBranch = this.organizationBranchOptions.find(x => x.value === id);
            return (organizationBranch && organizationBranch.label) || 'xác định';
        },
        isCheckinString(id) {
            let isCheckIn = this.isCheckInOptions.find(x => x.value === id);
            return (isCheckIn && isCheckIn.label) || 'Chưa xác định';
        },
        isLateString(id) {
            let isLate = this.isLateOptions.find(x => x.value === id);
            return (isLate && isLate.label) || 'Chưa xác định';
        },
        addEmployee() {
            this.$router.push(`/user/add-employee?branch_id=${this.selectedOrganizationBranchValue}`).catch(() => {
            });
        },
        validateForm() {
            return !this.errors.any()
        },
        filter() {
            let searchInfo = {
                organizationBranchId: this.selectedOrganizationBranchValue,
                employeeId: this.selectedEmployeeValue ? [this.selectedEmployeeValue] : null,
                start: moment(this.dateRange.startDate).set({hour: 0, minute: 0, second: 0, millisecond: 0}),
                end: moment(this.dateRange.endDate).set({hour: 23, minute: 59, second: 59, millisecond: 59}),
                isCheckIn: this.isCheckIn,
                isLate: this.isLate
            }
            this.$crm.post('/time-keeping/find', searchInfo).then((response) => {
                let workShiftData = response.data.sort((item1, item2) => {
                    if (moment(item1.date) > moment(item2.date)) return 1;
                    if (moment(item1.date) < moment(item2.date)) return -1;
                })
                this.workShiftData = workShiftData.map(item => {
                    item.displayGroupName = item.groupName + " - " + item.workShiftName;
                    let employee = this.employeeOptions.find(x => x.employeeCode === item.employeeCode);
                    item.employeeId = employee ? employee.value : null;

                    item.branchId = this.selectedOrganizationBranchValue;
                    item.actionTypeName = '';
                    if (item.actionType) {
                        switch (item.actionType) {
                            case 0:
                                item.actionTypeName = 'CameraAI';
                                break;
                            case 1:
                                item.actionTypeName = 'Wifi';
                                break;
                            case 2:
                                item.actionTypeName = 'QR Code';
                                break;
                            case 3:
                                item.actionTypeName = 'Quản lý duyệt';
                                break;
                            case 4:
                                item.actionTypeName = 'Khiếu nại chấm công';
                                break;
                            case 5:
                                item.actionTypeName = 'Chấm công từ xa';
                                break;
                            case 6:
                                item.actionTypeName = 'Pad';
                                break;
                            default:
                                break;
                        }
                    }
                    return item;
                })
                this.workShiftData = this.workShiftData.filter(x => x.employeeId);
                this.countElementPage = this.currentPage * this.paginationPageSize;
                this.totalElements = this.workShiftData.length;
                this.$vs.loading.close();
                setTimeout(() => {
                    if (this.$store.state.windowWidth > 1024) {
                        this.gridApi.sizeColumnsToFit();
                    }
                }, 100);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        exportFile() {
            if (this.workShiftData.length === 0) {
                return this.$vs.notify({
                    title: this.$t('message.error'),
                    text: 'Không có nhân viên nào !',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            } else {
                // eslint-disable-next-line no-unused-vars
                let branchId;
                let userInfo = JSON.parse(localStorage.getItem('userInfo'));
                if (userInfo.userRole !== 'organization') branchId = this.valueSelectedBranch ? this.valueSelectedBranch : userInfo.organizationBranchId;
                else branchId = this.valueSelectedBranch;
                let searchInfo = {
                    // organizationBranchId: branchId,
                    employeeId: this.selectedEmployee.value ? [this.selectedEmployee.value] : null,
                    start: moment(this.dateRange.startDate).set({hour: 0, minute: 0, second: 0, millisecond: 0}),
                    end: moment(this.dateRange.endDate).set({hour: 23, minute: 59, second: 59, millisecond: 59}),
                    isCheckIn: this.isCheckIn,
                    isLate: this.isLate,
                    departmentId: this.valueDepartment
                };
                this.$vs.loading();
                let url = searchInfo.employeeId ? '/time-keeping/create' : '/report-file/export-file'
                this.$crm.post(url, searchInfo).then(() => {
                    this.$router.push('/user/history-file');
                    this.$vs.loading.close();
                    // if (payload.employeeId) window.open(authConfig.crmDomain + "file/" + response.data.fileName + "?access_token=" + localStorage.getItem("access_token"), "_blank");
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: this.$t('message.error'),
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            }
        },
        onGridReady() {
            if (this.$store.state.windowWidth <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        loadEmployee() {
            if (!this.selectedOrganizationBranchValue) return;

            this.$vs.loading();
            this.$crm.post('/employee/find-by-organization-branch/' + this.selectedOrganizationBranchValue).then((response) => {
                this.employeeOptions = response.data.map(item => {
                    return {
                        value: item.employeeId,
                        label: item.employeeCode + " " + item.fullName,
                        employeeCode: item.employeeCode
                    }
                });
                if (this.employeeOptions.length > 0 && this.selectedEmployeeValue) {
                    this.selectedEmployee = this.employeeOptions.find(x => x.value === this.selectedEmployeeValue);
                }
                this.employeeOptions.unshift({value: null, label: this.$t('menuOrganization.all')})
                setTimeout(() => {
                    this.gridApi.sizeColumnsToFit();
                }, 180);
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        getInfoEmployee() {
            return new Promise((resolve) => {
                this.$vs.loading();
                this.$crm.post('/employee/find-by-id/' + this.selectedEmployeeValue).then((response) => {
                    this.selectedOrganizationBranchValue = response.data.organizationBranchId;
                    resolve();
                    this.$vs.loading.close();
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        }
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
    },
}
</script>

<style scoped>

</style>
